const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['prompt', [this, 'block_prompt']],
                    ['hidden_inputs', [this, 'block_hidden_inputs']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<form
  class="c-comment-form`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(2, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`"
  `);
                if ((context.has(`heading_id`) ? context.get(`heading_id`) : null)) {
                    this.echo(`aria-labelledby="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(3, this.source)(...[this.env, (context.has(`heading_id`) ? context.get(`heading_id`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                if ((context.has(`action`) ? context.get(`action`) : null)) {
                    this.echo(`action="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, (context.has(`action`) ? context.get(`action`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                if ((context.has(`method`) ? context.get(`method`) : null)) {
                    this.echo(`method="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`method`) ? context.get(`method`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`>
  `);
                this.traceableDisplayBlock(7, this.source)('prompt', context.clone(), blocks);
                this.echo(`
  `);
                this.echo(`  `);
                this.traceableDisplayBlock(33, this.source)('hidden_inputs', context.clone(), blocks);
                this.echo(`
  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 35, 32), new Map([[`label`, (((context.has(`main_label`))) ? (this.env.getFilter('default').traceableCallable(35, this.source)(...[(context.has(`main_label`) ? context.get(`main_label`) : null), `Message`])) : (`Message`))]]), true, false, 35));
                this.echo(`  `);
                if (!!((context.has(`logged_in_user`) ? context.get(`logged_in_user`) : null) && (context.has(`log_out_url`) ? context.get(`log_out_url`) : null))) {
                    this.echo(`    <p>Logged in as <a href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(47, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 47, this.source)(this.env, (context.has(`logged_in_user`) ? context.get(`logged_in_user`) : null), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(47, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 47, this.source)(this.env, (context.has(`logged_in_user`) ? context.get(`logged_in_user`) : null), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</a>. <a href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(47, this.source)(...[this.env, (context.has(`log_out_url`) ? context.get(`log_out_url`) : null), `html`, null, true]));
                    this.echo(`">Log out?</a></p>
  `);
                }
                else {
                    this.echo(`    `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 49, 33), new Map([[`label`, `Name`], [`class`, `c-comment-form__name`]]), false, false, 49));
                    this.echo(`    `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 54, 34), new Map([[`label`, `Email`], [`class`, `c-comment-form__email`]]), false, false, 54));
                    this.echo(`  `);
                }
                this.echo(`  <label class="o-media">
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/checkbox/checkbox.twig`, new Map([[`name`, `subscribe_comments`], [`class`, `o-media__object`]]), false, false, 61));
                this.echo(`    <span class="o-media__content">Notify me of follow-up comments by email.</span>
  </label>
  `);
                if ((context.has(`is_reply`) ? context.get(`is_reply`) : null)) {
                    this.echo(`    `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 65, 35), new Map([[`grow`, true], [`class`, `c-comment-form__reply-actions`]]), false, false, 65));
                    this.echo(`  `);
                }
                else {
                    this.echo(`    `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Submit Comment`]]), false, false, 72));
                    this.echo(`  `);
                }
                this.echo(`</form>
`);
            }

            block_prompt(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.proxy[`_heading_tag`] = (((context.has(`heading_tag`))) ? (this.env.getFilter('default').traceableCallable(8, this.source)(...[(context.has(`heading_tag`) ? context.get(`heading_tag`) : null), `h2`])) : (`h2`));
                this.echo(`    <`);
                this.echo(this.env.getFilter('escape').traceableCallable(9, this.source)(...[this.env, (context.has(`_heading_tag`) ? context.get(`_heading_tag`) : null), `html`, null, true]));
                this.echo(`
      `);
                if ((context.has(`heading_id`) ? context.get(`heading_id`) : null)) {
                    this.echo(`id="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(10, this.source)(...[this.env, (context.has(`heading_id`) ? context.get(`heading_id`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`      `);
                if ((context.has(`heading_class`) ? context.get(`heading_class`) : null)) {
                    this.echo(`class="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(11, this.source)(...[this.env, (context.has(`heading_class`) ? context.get(`heading_class`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`    >
      `);
                this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (((context.has(`heading_text`))) ? (this.env.getFilter('default').traceableCallable(13, this.source)(...[(context.has(`heading_text`) ? context.get(`heading_text`) : null), `Leave a Comment`])) : (`Leave a Comment`)), `html`, null, true]));
                this.echo(`
    </`);
                this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`_heading_tag`) ? context.get(`_heading_tag`) : null), `html`, null, true]));
                this.echo(`>

    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 16, 31), undefined, true, false, 16));
                this.echo(`  `);
            }

            block_hidden_inputs(context, blocks = new Map()) {
                let macros = this.macros.clone();
            }

            getTemplateName() {
                return `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, ``);
            }
        }],
        [31, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/alert/alert.twig`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 16);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/alert/alert.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <p `);
                if ((context.has(`help_text_id`) ? context.get(`help_text_id`) : null)) {
                    this.echo(`id="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(18, this.source)(...[this.env, (context.has(`help_text_id`) ? context.get(`help_text_id`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`>
          Please be kind, courteous and constructive.
          You may use simple HTML or
          <a href="https://en.support.wordpress.com/markdown-quick-reference">Markdown</a>
          in your comments.
          All fields are required.
        </p>
      `);
            }

            getTemplateName() {
                return `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, ``);
            }
        }],
        [32, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/form-group/form-group.twig`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 35);

                this.blocks = new Map([
                    ['control', [this, 'block_control']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/form-group/form-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_control(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, new Map([[`type`, `textarea`], [`name`, `comment`], [`required`, true], [`class`, `js-elastic-textarea`], [`aria-describedby`, (context.has(`help_text_id`) ? context.get(`help_text_id`) : null)]]), false, false, 37));
                this.echo(`    `);
            }

            getTemplateName() {
                return `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, ``);
            }
        }],
        [33, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/form-group/form-group.twig`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 49);

                this.blocks = new Map([
                    ['control', [this, 'block_control']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/form-group/form-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_control(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, new Map([[`name`, `author`], [`autocomplete`, `name`], [`required`, true]]), false, false, 51));
                this.echo(`      `);
            }

            getTemplateName() {
                return `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, ``);
            }
        }],
        [34, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/form-group/form-group.twig`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 54);

                this.blocks = new Map([
                    ['control', [this, 'block_control']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/form-group/form-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_control(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, new Map([[`name`, `email`], [`type`, `email`], [`autocomplete`, `home email`], [`required`, true]]), false, false, 56));
                this.echo(`      `);
            }

            getTemplateName() {
                return `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, ``);
            }
        }],
        [35, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/button-group/button-group.twig`, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, 65);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/button-group/button-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Submit Reply`]]), false, false, 67));
                this.echo(`        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Cancel`], [`class`, `c-button--secondary js-cancel-reply`], [`type`, `button`]]), false, false, 68));
                this.echo(`      `);
            }

            getTemplateName() {
                return `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552');

let template = env.loadTemplate('fcd1f97058261efb9d45b286517be0ac911ae8a0658ede3c443df04e1ea3f552');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/comment-form/comment-form.twig", args: context }
     );
     return rendered;;
};